module.exports = __webpack_public_path__ + "img/waze.c4e0a7a0.png";